(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    /* ZQUARO: al pasar el ratón por una bolita de color, la foto de la tarjeta cambia a ese color */
    if (window.__zqCardSw) return;
    window.__zqCardSw = true;

    function visibleImg(card) {
      var slide = card.querySelector('slideshow-slide[aria-hidden="false"]:not([hidden])') || card.querySelector('slideshow-slide:not([hidden])');
      return slide ? slide.querySelector('img') : card.querySelector('.card-gallery img');
    }

    function show(card, mediaId) {
      var src = card.querySelector('slideshow-slide[slide-id="' + mediaId + '"] img');
      var img = visibleImg(card);
      if (!src || !img || src === img) return;
      if (!img.dataset.zqOrigSrc) {
        img.dataset.zqOrigSrc = img.getAttribute('src') || '';
        img.dataset.zqOrigSrcset = img.getAttribute('srcset') || '';
      }
      if (src.getAttribute('srcset')) img.setAttribute('srcset', src.getAttribute('srcset'));
      img.setAttribute('src', src.getAttribute('src'));
      card.__zqImg = img;
    }

    function restore(card) {
      var img = card.__zqImg;
      if (!img || !img.dataset.zqOrigSrc) return;
      img.setAttribute('src', img.dataset.zqOrigSrc);
      if (img.dataset.zqOrigSrcset) img.setAttribute('srcset', img.dataset.zqOrigSrcset);
      else img.removeAttribute('srcset');
      delete img.dataset.zqOrigSrc;
      delete img.dataset.zqOrigSrcset;
      card.__zqImg = null;
    }

    document.addEventListener('pointerover', function (e) {
      var label = e.target.closest && e.target.closest('product-card .variant-option__button-label[data-media-id]');
      if (!label) return;
      var card = label.closest('product-card');
      clearTimeout(card.__zqT);
      show(card, label.dataset.mediaId);
    });

    document.addEventListener('pointerout', function (e) {
      var label = e.target.closest && e.target.closest('product-card .variant-option__button-label[data-media-id]');
      if (!label) return;
      if (e.relatedTarget && label.contains(e.relatedTarget)) return;
      var card = label.closest('product-card');
      clearTimeout(card.__zqT);
      card.__zqT = setTimeout(function () { restore(card); }, 120);
    });

    /* Al pulsar una bolita el tema muestra la foto de ese color: dejamos de previsualizar */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!(input instanceof HTMLInputElement) || !input.closest('product-card product-swatches')) return;
      var card = input.closest('product-card');
      clearTimeout(card.__zqT);
      restore(card);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["zq-pdp"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__zqPdp) return;
    window.__zqPdp = true;

    /* Guía de tallas: el enlace se coloca junto al título "Talla" */
    function placeSizeLink() {
      document.querySelectorAll('[data-zq-sg]').forEach(function (holder) {
        var section = holder.closest('.product-information') || document;
        var fieldsets = section.querySelectorAll('variant-picker fieldset');
        var target = null;
        fieldsets.forEach(function (fs) {
          var lg = fs.querySelector('legend');
          if (lg && /talla|size/i.test(lg.textContent)) target = lg;
        });
        if (!target || target.querySelector('.zq-sg-link')) return;
        var link = holder.querySelector('.zq-sg-link').cloneNode(true);
        link.style.display = 'inline-flex';
        target.appendChild(link);
      });
    }

    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-zq-sg-open]');
      if (open) {
        e.preventDefault();
        var holder = document.querySelector('[data-zq-sg]');
        var dlg = holder && holder.querySelector('dialog');
        if (dlg && !dlg.open) dlg.showModal();
        return;
      }
      if (e.target.closest('[data-zq-sg-close]')) {
        e.target.closest('dialog').close();
        return;
      }
      if (e.target.matches && e.target.matches('dialog.zq-sg')) {
        var r = e.target.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
      }
    });

    /* Completa tu look: muestra las prendas del color elegido */
    function syncLook() {
      var look = document.querySelector('[data-zq-look]');
      if (!look) return;
      var section = look.closest('.product-information') || document;
      var checked = null;
      section.querySelectorAll('variant-picker input[type="radio"]:checked').forEach(function (i) {
        if (/^colou?r$/i.test(i.dataset.optionName || '')) checked = i;
      });
      if (!checked) return;
      var lists = look.querySelectorAll('[data-zq-look-color]');
      var any = false;
      lists.forEach(function (ul) {
        var on = ul.getAttribute('data-zq-look-color') === checked.value;
        ul.hidden = !on;
        if (on) any = true;
      });
      look.hidden = !any;
    }

    function run() {
      placeSizeLink();
      syncLook();
    }
    document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('change', function () {
      setTimeout(run, 0);
    });
    new MutationObserver(function () {
      placeSizeLink();
    }).observe(document.documentElement, { childList: true, subtree: true });
    run();
  })();
  } catch(e) { console.error(e); }
})();

})();
